import type { ApiEndpoints } from '@avisoma/shared';

type ModelHash = ApiEndpoints<string>['/api/system/model-hash']['GET']['response'];

type ModelHashBadgeProps = {
  data: ModelHash | null | undefined;
  isLoading: boolean;
  isError: boolean;
};

export default function ModelHashBadge({ data, isLoading, isError }: ModelHashBadgeProps) {

  if (isError) {
    return null;
  }

  const isEmptyModel = !!data && [data.categories, data.categoryClusters, data.rcEmbeddings].every((hash) => hash === 'empty');
  const combined = isLoading || !data ? '…' : isEmptyModel ? 'empty' : data.combined;

  const tooltip = data
    ? [
        isEmptyModel ? 'No model loaded' : 'Model loaded',
        `combined:   ${data.combined}`,
        `categories: ${data.categories}`,
        `clusters:   ${data.categoryClusters}`,
        `rc:         ${data.rcEmbeddings}`,
      ].join('\n')
    : 'Loading model hash…';

  return (
    <span
      title={tooltip}
      className="font-mono text-xs text-zinc-500 dark:text-zinc-400 cursor-help select-text"
    >
      <span className="text-zinc-400 dark:text-zinc-500">model:</span> {combined}
    </span>
  );
}
